import { v4 as uuidv4 } from 'uuid';
import { getAuthSession } from './api';

async function initLogin() {
    const session = getAuthSession();
    this.type = this.page.params.type || session.type;
    this.observed.type = uuidv4();
    // Signal session check is complete — no valid session found.
    // PrivateRoute gates on this to avoid a permanent blank page for anonymous/expired users.
    this.observed.initialized = uuidv4();
}

export default initLogin;
